// extracted by mini-css-extract-plugin
module.exports = {"container":"ccfda6eb9f--container--Ozvd2","content":"ccfda6eb9f--content--vxTla","form":"ccfda6eb9f--form--KISfO"};